
import { form10StatusInfoType } from '@/types/Information/Form10';
import { Component, Prop, Vue } from 'vue-property-decorator';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form10ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form10StatusInfoType;

}
